<template>
  <v-flex d-flex>
    <v-container fluid>
      <v-card class="px-2 pb-2 mb-3">
        <v-card-title primary-title>
          <span class="title">{{ $route.meta.title }}</span>
        </v-card-title>
      </v-card>
      <BotReportVolume></BotReportVolume>
    </v-container>
  </v-flex>
</template>

<script>
import BotReportVolume from './ExportReport/BotReportVolume';

export default {
  components: {
    BotReportVolume,
  },
};
</script>
